import { createAsyncThunk } from "@reduxjs/toolkit";
import { StoreState } from "../index";
import { ProfessionnelService } from "../../../core/services/professionnel.service";
import {
	EnvoiSyntheseTleMode,
	PreferencesSollicitation,
	SaisieInfosFacturationSollicitation,
	TypeSollicitation,
	TypeUtilisateurSollicitation,
} from "../../../core/apis/monsisra/generated";
import { UtilsService } from "../../../core/services/utils.service";
import { toast } from "react-toastify";
import { FileService } from "../../../core/services/file.service";

const service = new ProfessionnelService();
const fileService = new FileService();
const util = new UtilsService();

export const getPreferences = createAsyncThunk("expertise/getPreferences", async (idTechPs: string, { getState }): Promise<PreferencesSollicitation> => {
	const { expertise } = getState() as StoreState;

	const defaultValue: PreferencesSollicitation = {
		statutDansAnnuaire: false,
		centragePatient: true,
		msContactTeleExpertiseOnly: false,
		msContactDAOnly: false,
		description: "",
		preferencesFacturationExpert: {
			numeroDemandeurRequis: false,
			nir: SaisieInfosFacturationSollicitation.Invisibles,
		},
		preferencesEnvoiSyntheseTleExpert: {
			modeEnvoiMss: EnvoiSyntheseTleMode.TO_EXPERT_SOLLICITE,
		},
		prerequis: {
			message: "",
			echangeBullePrerequis: "",
			files: [],
		},
		numeroFacturation: "",
		idTechPsExpert: idTechPs,
		urlOutil: undefined,
		typeUtilisateurSollicitation: expertise.type === TypeSollicitation.TeleExpertise ? TypeUtilisateurSollicitation.Expert : TypeUtilisateurSollicitation.EquipeRessource,
		modeChatActif: true,
		preferencesRestriction: {
			dailyTeleExpertiseLimitEnabled: false,
			limitToAutorizedProfessionsAndSpecialites: false,
			autorizedProfessionIds: [],
			autorizedSpecialites: [],
		},
	};

	try {
		const data = await service.getPreferenceSollicitation(idTechPs, expertise.type);
		return util.deepMerge(defaultValue, data);
	} catch (e) {
		return defaultValue;
	}
});

let toastId = 0;
export const savePreferences = createAsyncThunk("expertise/savePreferences", async (_: void, { getState }): Promise<PreferencesSollicitation> => {
	const id = toastId++;

	const preferencesCb = async () => {
		try {
			let {
				auth: { user },
				expertise: { preferences, useMonSisra },
			} = getState() as StoreState;
			if (!user) {
				throw new Error("You must be logged to save Preferences");
			}
			if (!preferences) {
				throw new Error("property preferences must be valid");
			}
			if (useMonSisra) {
				preferences = {
					...preferences,
					urlOutil: undefined,
				};
			}
			preferences = await service.setPreferenceSollicitation(user.idTechPs, preferences);
			return preferences;
		} catch (e) {
			console.error("expertise/savePreferences", e);
			throw e;
		}
	};

	return toast.promise(
		preferencesCb,
		{
			pending: "Sauvegarde des préférences en cours ...",
			success: "Les préférences ont bien été sauvegardées",
			error: "Erreur lors de la sauvegarde des préférences",
		},
		{ hideProgressBar: true, updateId: id, toastId: id }
	);
});

export const getTypesFormulaire = createAsyncThunk("expertise/getTypesFormulaire", async (_, { getState }) => {
	const {
		expertise: { type },
	} = getState() as StoreState;
	return await service.getPreferenceConfig(type);
});

export const getFichierSollicitation = createAsyncThunk("expertise/getFichierSollicitation", async (idFichierSollicitation: string, { getState }) => {
	const {
		expertise: { type },
	} = getState() as StoreState;

	const id = toastId++;

	const result = await toast.promise(
		service.getFichierSollicitation(idFichierSollicitation, type),
		{
			pending: "Téléchargement de la pièce jointe en cours ...",
			success: "La pièce jointe a bien été téléchargée.",
			error: "Erreur lors du téléchargement de la pièce jointe",
		},
		{ hideProgressBar: true, updateId: id, toastId: id }
	);

	fileService.downloadFile(result);
});

export const fetchProfessionsAndSpecialites = createAsyncThunk("expertise/fetchProfessionsAndSpecialites", async () => {
	return await service.getProfessionsAndSpecialites();
});
